import axios from "axios";
import { isCookieEnabled, getCookie } from "tiny-cookie";

import config from "../../../build/config"

let SERVER_BASE_URL = config.BACKEND_URL;

const getRequest = function(url, data, resolve, reject, timeout = 600000) {
  const config = {
    baseURL: SERVER_BASE_URL,
    timeout: timeout,
    headers: {
      "Content-Type": "application/json"
    }
  };
  const token = isCookieEnabled() ? getCookie("id_token") : "";
  if (token) {
    config.headers["Authorization"] = `JWT ${token}`;
  }
  const instance = axios.create(config);
  instance
    .get(url, data)
    .then(res => {
      resolve(res);
    })
    .catch(error => {
      // checkAuthorization(error.response.status);
      reject(error);
    });
};

const postRequest = function(url, data, resolve, reject, timeout = 600000) {
  const config = {
    baseURL: SERVER_BASE_URL,
    timeout: timeout,
    headers: {
      "Content-Type": "application/json"
    }
  };
  const token = isCookieEnabled() ? getCookie("id_token") : "";
  if (token) {
    config.headers["Authorization"] = `JWT ${token}`;
  }
  const instance = axios.create(config);
  instance
    .post(url, data)
    .then(res => {
      resolve(res);
    })
    .catch(error => {
      // checkAuthorization(error.response.status);
      reject(error);
    });
};

const deleteRequest = function(url, data, resolve, reject, timeout = 1000) {
  const config = {
    baseURL: SERVER_BASE_URL,
    timeout: timeout,
    headers: {
      "Content-Type": "application/json"
    }
  };
  const token = isCookieEnabled() ? getCookie("id_token") : "";
  if (token) {
    config.headers["Authorization"] = `JWT ${token}`;
  }
  const instance = axios.create(config);
  instance
    .delete(url, data)
    .then(res => {
      resolve(res);
    })
    .catch(error => {
      reject(error);
    });
};

const putRequest = function(url, data, resolve, reject, timeout = 600000) {
  const config = {
    baseURL: SERVER_BASE_URL,
    timeout: timeout,
    headers: {
      "Content-Type": "application/json"
    }
  };
  const token = isCookieEnabled() ? getCookie("id_token") : "";
  if (token) {
    config.headers["Authorization"] = `JWT ${token}`;
  }
  const instance = axios.create(config);
  instance
    .put(url, data)
    .then(res => {
      resolve(res);
    })
    .catch(error => {
      // checkAuthorization(error.response.status);
      reject(error);
    });
};

export default {
  getRequest,
  postRequest,
  deleteRequest,
  putRequest
};



// WEBPACK FOOTER //
// ./src/store/api/ajax.js